import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login';  
const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    {
      path:'/',
      name:'login',
      component:Login,
    },
    {
      path:'/register',
      name:'register',
      component:resolve => require(['@/view/register'], resolve),
    },
    {
      path:'/WeChat',
      name:'WeChat',
      component:resolve => require(['@/view/WeChat'], resolve),
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/view/index'], resolve),
      redirect: { name: 'home' },
      children: [
        {  
          path: '/home',  //首页总览
          name: 'home',
          component: resolve => require(['@/view/home'], resolve)
        },
        {
          path: '/ProjectHall',  //项目大厅
          name: 'ProjectHall',
          component: resolve => require(['@/view/ProjectHall'], resolve)
        },
        {
          path: '/CoursewareReview',  //项目大厅
          name: 'CoursewareReview',
          component: resolve => require(['@/view/CoursewareReview'], resolve)
        },
        {
          path:'/TextEditor',   //发布工单
          name:'TextEditor',
          component:resolve => require(['@/view/TextEditor'], resolve),
        },
        {
          path:'/historywork',   //发布工单历史列表
          name:'historywork',
          component:resolve => require(['@/view/historywork'], resolve),
        },
        {
          path:'/refund',   //退费列表
          name:'refund',
          component:resolve => require(['@/view/refund'], resolve),
        },
        {
          path:'/drafts',   //发布工单草稿箱
          name:'drafts',
          component:resolve => require(['@/view/drafts'], resolve),
        },
        {
          path:'/clockin',   //考勤打卡
          name:'clockin',
          component:resolve => require(['@/view/clockin'], resolve),
        },
        {
          path:'/other',   //考勤其他
          name:'other',
          component:resolve => require(['@/view/other'], resolve),
        },
        {
          path:'/activity',   //活动
          name:'activity',
          component:resolve => require(['@/view/activity'], resolve),
        },
        {
          path:'/CoursewareReviews',   //课件审核
          name:'CoursewareReviews',
          component:resolve => require(['@/view/CoursewareReviews'], resolve),
        },
        {
          path:'/CourseLibraryNew',
          name:'CourseLibraryNew',
          component:resolve => require(['@/view/CourseLibraryNew'], resolve),
        },
        {   //各省使用
          path:'/Provincialusage',
          name:'Provincialusage',
          component:resolve => require(['@/view/Provincialusage'], resolve),
        },
        {  //历年课程
          path:'/CoursesOvertheYears',
          name:'CoursesOvertheYears',
          component:resolve => require(['@/view/CoursesOvertheYears'], resolve),
        },
        {
          path:'/refundDraft',   //退费草稿箱
          name:'refundDraft',
          component:resolve => require(['@/view/refundDraft'], resolve),
        },
        {
          path:'/personnel',    //人员
          name:'personnel',
          component:resolve => require(['@/view/personnel'], resolve),
        },
        {
          path:'/TableBar',
          name:'TableBar',
          component:resolve => require(['@/view/TableBar'], resolve),
        },
        {
          path:'/Customerservice',   //客服工单
          name:'Customerservice',
          component:resolve => require(['@/view/Customerservice'], resolve),
        },
        {
          path:'/Invoiceworkorder',   //发票工单
          name:'Invoiceworkorder',
          component:resolve => require(['@/view/Invoiceworkorder'], resolve),
        },
        {
          path:'/overtime',   //加班单
          name:'overtime',
          component:resolve => require(['@/view/overtime'], resolve),
        },
        {
          path:'/Reimbursement',
          name:'Reimbursement',
          component:resolve => require(['@/view/Reimbursement'], resolve),
        },
        {
          path:'/Travelexpenses',
          name:'Travelexpenses',
          component:resolve => require(['@/view/Travelexpenses'], resolve),
        },
        {
          path:'/document',    //文档列表
          name:'document',
          component:resolve => require(['@/view/document'], resolve),
        },
        {
          path:'/news',
          name:'news',
          component:resolve => require(['@/view/news'], resolve),
        },
        {
          path:'/operations',
          name:'operations',
          component:resolve => require(['@/view/operations'], resolve),
        },
        {
          path:'/remittance',  //集体汇款
          name:'remittance',
          component:resolve => require(['@/view/remittance'], resolve),
        },
        {
          path:'/websitelog',
          name:'websitelog',
          component:resolve => require(['@/view/websitelog'], resolve),
        },
        {
          path:'/websitelogTwo',
          name:'websitelogTwo',
          component:resolve => require(['@/view/websitelogTwo'], resolve),
        },
        {
          path:'/websitelogThree',
          name:'websitelogThree',
          component:resolve => require(['@/view/websitelogThree'], resolve),
        },
        {
          path:'/recording',
          name:'recording',
          component:resolve => require(['@/view/recording'], resolve),
        },
        {
          path:'/statistics',    //统计
          name:'statistics',
          component:resolve => require(['@/view/statistics'], resolve),
        },
        {
          path:'/request',
          name:'request',
          component:resolve => require(['@/view/request'], resolve),
        },
        {
          path:'/work',
          name:'work',
          component:resolve => require(['@/view/work'], resolve),
        },
        {
          path:'/MyworkOrder',   //我的工单
          name:'MyworkOrder',
          component:resolve => require(['@/view/MyworkOrder'], resolve),
        },
        {
          path:'/processing',     //待处理
          name:'processing',
          component:resolve => require(['@/view/processing'], resolve),
        },
        {
          path:'/message',   //消息
          name:'message',
          component:resolve => require(['@/view/message'], resolve),
        },
        //审核
        {
          path:'/examine_overtime',     //审核_加班单
          name:'examine_overtime',
          component:resolve => require(['@/view/examine_overtime'], resolve),
        },
        {
          path:'/examine_TableBar',
          name:'examine_TableBar',
          component:resolve => require(['@/view/examine_TableBar'], resolve),
        },
        {
          path:'/examine_Reimbursement',
          name:'examine_Reimbursement',
          component:resolve => require(['@/view/examine_Reimbursement'], resolve),
        },
        {
          path:'/examine_Travelexpenses',
          name:'examine_Travelexpenses',
          component:resolve => require(['@/view/examine_Travelexpenses'], resolve),
        },
        {
          path:'/examine_goout',
          name:'examine_goout',
          component:resolve => require(['@/view/examine_goout'], resolve),
        },  
        {
          path:'/examine_eliminates',
          name:'examine_eliminates',
          component:resolve => require(['@/view/examine_eliminates'], resolve),
        }, 
        //统计开始
        {
          path:'/vacation',
          name:'vacation',
          component:resolve => require(['@/view/vacation'], resolve),
        },
        {
          path:'/expense',
          name:'expense',
          component:resolve => require(['@/view/expense'], resolve),
        },
        {
          path:'/tjclockin',   //统计打卡
          name:'tjclockin',
          component:resolve => require(['@/view/tjclockin'], resolve),
        },
        {
          path:'/allowance',   //统计餐补
          name:'allowance',
          component:resolve => require(['@/view/allowance'], resolve),
        },  //统计结束
        {
          path:'/ProvincialTime',   //各省时间
          name:'ProvincialTime',
          component:resolve => require(['@/view/ProvincialTime'], resolve),
        },
        {
          path:'/ProvinceRule',   //各省规则
          name:'ProvinceRule',
          component:resolve => require(['@/view/ProvinceRule'], resolve),
        },
        {
          path:'/CompanyMaterials',   //公司材料
          name:'CompanyMaterials',
          component:resolve => require(['@/view/CompanyMaterials'], resolve),
        },
        {
          path:'/openedinvoice',   //已开发票
          name:'openedinvoice',
          component:resolve => require(['@/view/openedinvoice'], resolve),
        },
        {
          path:'/goout',   //外出单
          name:'goout',
          component:resolve => require(['@/view/goout'], resolve),
        },  //其他公司审核
        {
          path:'/examine_overtimeTwo',     //审核_加班单
          name:'examine_overtimeTwo',
          component:resolve => require(['@/view/examine_overtimeTwo'], resolve),
        },
        {
          path:'/examine_TableBarTwo',
          name:'examine_TableBarTwo',
          component:resolve => require(['@/view/examine_TableBarTwo'], resolve),
        },
        {
          path:'/examine_ReimbursementTwo',
          name:'examine_ReimbursementTwo',
          component:resolve => require(['@/view/examine_ReimbursementTwo'], resolve),
        },
        {
          path:'/examine_TravelexpensesTwo',
          name:'examine_TravelexpensesTwo',
          component:resolve => require(['@/view/examine_TravelexpensesTwo'], resolve),
        },
        {
          path:'/examine_gooutTwo',
          name:'examine_gooutTwo',
          component:resolve => require(['@/view/examine_gooutTwo'], resolve),
        }, //其他公司统计
        {
          path:'/vacationTwo',
          name:'vacationTwo',
          component:resolve => require(['@/view/vacationTwo'], resolve),
        },
        {
          path:'/expenseTwo',
          name:'expenseTwo',
          component:resolve => require(['@/view/expenseTwo'], resolve),
        },
        {
          path:'/tjclockinTwo',   //统计打卡
          name:'tjclockinTwo',
          component:resolve => require(['@/view/tjclockinTwo'], resolve),
        },
        {
          path:'/allowanceTwo',   //统计餐补
          name:'allowanceTwo',
          component:resolve => require(['@/view/allowanceTwo'], resolve),
        },  //其他公司统计结束
      ]
    },
  ]
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js